// groups date ranges

// method to group elements in array
import groupElements from './../../scripts/reusable/group-array-elements'
// method to format date
import formatDate from './../../scripts/reusable/format-date'

const chunk = require('chunk-date-range')

const groupDateRanges = (arr) => {
  let start = arr.start.substring(0, arr.start.indexOf('T'))
  let end = arr.end.substring(0, arr.end.indexOf('T'))
  let arrGrouped = groupElements(arr.counts)
  let isEmpty = true

  arrGrouped.forEach(function(obj) {
    if(obj.results > 0) {
      isEmpty = false
    }
  })

  let arrIntervals = arrGrouped.length > 1 && !isEmpty ? chunk(start, end, 10) : chunk(start, end, 1)

  arrIntervals.forEach(function(value) {
    value.results = 0

    if (arrGrouped.length > 1) {
      arrGrouped.forEach(function(obj) {
        let date = new Date(obj.name)
        if(date >= value.start && date < value.end) {
          value.results += obj.results
        }
      })
    } else {
      value.results = arrGrouped[0].results
    }

    value.start = formatDate(value.start)
    value.end = formatDate(value.end)
  })

  return arrIntervals
}

const setDateGap = (data) => {
  let start = new Date(data.start)
  let end = new Date(data.end)
  let timeDiff = Math.abs(end.getTime() - start.getTime())
  let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24))

  let gap = diffDays >=10 ? Math.ceil(diffDays/10) : diffDays
  gap = gap > 0 ? gap : 1
  return gap
}

export {
  groupDateRanges,
  setDateGap
}



// WEBPACK FOOTER //
// ./src/store/reusable/group-date-ranges.js